import { AccountRecord } from '@tassat/fred-definitions';

import { FirmWalletsAgGrid } from './firmAccountWalletsGrid';

export interface FirmWalletsGridProps {
    wallets: AccountRecord[];
}

export default FirmWalletsAgGrid;